import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("admin@tulsi.com");
  const [password, setPassword] = useState("tulsi123");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      const m = err?.response?.data?.detail;
      toast.error(typeof m === "string" ? m : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background">
      {/* Left side: brand panel */}
      <div className="hidden md:flex relative overflow-hidden bg-brand-forest text-white p-12 flex-col justify-between">
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/11255309/pexels-photo-11255309.jpeg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'grayscale(40%) brightness(0.4)',
          }}
        />
        <div className="relative">
          <img src="/logo512.png" alt="Tulsi Trading & Logistics" data-testid="login-logo"
            className="h-24 w-24 rounded-full object-contain bg-white/90 p-1 mb-5 shadow-lg" />
          <div className="text-xs uppercase tracking-[0.3em] text-brand-sand">est. 2026</div>
          <div className="mt-6 font-serif text-5xl leading-[1.05] tracking-tight">
            Tulsi<br/>
            <span className="text-brand-sand italic font-light">Trading</span><br/>
            & Logistics
          </div>
        </div>
        <div className="relative space-y-1">
          <div className="text-xs uppercase tracking-[0.2em] text-white/50">Accounts & Billing Suite</div>
          <div className="text-sm text-white/80 max-w-xs leading-relaxed">
            Truck-wise releases, party ledgers, GST-compliant invoices — all under one roof.
          </div>
        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="mb-10">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand-muted mb-3">Sign in</div>
            <h1 className="font-serif text-4xl text-brand-ink tracking-tight">Welcome back</h1>
            <p className="mt-2 text-sm text-brand-muted">Access your billing & accounts workspace.</p>
          </div>
          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-[0.15em] text-brand-muted">Email</Label>
              <Input
                id="email" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="mt-2 h-11 rounded-sm border-brand-line bg-white"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-[0.15em] text-brand-muted">Password</Label>
              <Input
                id="password" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="mt-2 h-11 rounded-sm border-brand-line bg-white"
                required
              />
            </div>
            <Button
              type="submit"
              disabled={busy}
              data-testid="login-submit-btn"
              className="w-full h-11 rounded-sm bg-brand-forest hover:bg-brand-forestDark text-white uppercase tracking-[0.18em] text-xs"
            >
              {busy ? "Signing in…" : "Sign In"}
            </Button>
            <p className="text-xs text-brand-muted text-center pt-4">
              Default admin: admin@tulsi.com / tulsi123
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
